module.exports = __webpack_public_path__ + "static/media/img3Mobile.772f7294.jpg";